<template>
  <div class="loan-card">
    <div class="loan-content">
      <div class="load-heand-info">
        <div class="info-item">
          <span>年利率：</span>
          <span>{{ pendingPlan.annualizedRatio || '---' }}%</span>
        </div>
        <div class="step-img">
          <img src="@/assets/style/load-step-icon.png" alt="" />
        </div>
        <div class="info-item">
          <span>还款期数：</span>
          <span>{{ pendingPlan.issueOrderNum || '---' }}期</span>
        </div>
        <div class="step-img">
          <img src="@/assets/style/load-step-icon.png" alt="" />
        </div>
        <div class="info-item">
          <span>每期天数：</span>
          <span>{{ pendingPlan.issueDay || '---' }}天</span>
        </div>
      </div>
      <div class="load-amount-title">可用额度(元)</div>
      <div class="load-amount">{{ amountFormatter(pendingPlan.remainCreditAmount) || '---' }}</div>
      <div class="load-amount-tip">
        最小借贷金额<span>{{ amountFormatter(pendingPlan.minBorrowAmount) || '---' }}</span
        >/最多同时借<span>{{ pendingPlan.multipleLimitNum || '---' }}</span
        >笔
      </div>
      <div class="load-card-tab">
        <div class="tab-item" @click="handSelectCard">
          <div class="top">
            <div
              class="tab-item-left"
              :style="{ color: bankInfo.bankName ? '#333333' : '#FF0000' }"
            >
              <span>收款账户</span>
              <img src="@/assets/style/card-icon.png" alt="" />
            </div>
            <div class="tab-item-right">
              <span class="span">{{ bankInfo.bankName ? "换卡" : "绑定" }}</span>
              <img src="@/assets/style/load-right-icon.png" alt="" />
            </div>
          </div>
          <div class="bottom" v-if="bankInfo.bankName">
            <span>{{ receivedBank.bankName || bankInfo.bankName || "无" }}</span>
            <span>（{{ maskBankCard(receivedBank.bankNumber) || maskBankCard(bankInfo.bankNumber) || "无" }}）</span>
          </div>
          <div class="no-bank" style="color: #ff0000" v-else>
            <span>---</span>
          </div>
        </div>
        <div class="tab-item" @click="handApplicationList">
          <div class="top">
            <div class="tab-item-left">
              <span>用途</span>
              <img src="@/assets/style/application-icon.png" alt="" />
            </div>
            <div class="tab-item-right">
              <span class="span">更多</span>
              <img src="@/assets/style/load-right-icon.png" alt="" />
            </div>
          </div>
          <div class="bottom">
            <span>{{ borrowPurpose || "个人消费" }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--选择银行卡-->
    <selectBankCardPopup ref="selectBankCardPopupRef" />
    <!--选择用途-->
    <selectUseList ref="selectUseListRef" />
  </div>
</template>

<script>
import selectBankCardPopup from "@/components/loan/selectBankCardPopup.vue";
import selectUseList from "@/components/loan/selectUseList.vue";
import { maskBankCard } from "@/utils/utils";
import { amountFormatter } from "@/utils/utils";

export default {
  name: "LoanCard",
  components: {
    selectBankCardPopup,
    selectUseList,
  },
  props: {
    pendingPlan: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      maskBankCard,
      amountFormatter,
    };
  },
  async mounted() {},
  methods: {
    handApplicationList() {
      this.$refs.selectUseListRef.init();
    },
    handSelectCard() {
      if (this.bankInfo.bankName) {
        this.$refs.selectBankCardPopupRef.init();
      } else {
        this.$router.push({
          name: "bankCardBinding",
          query: {
            type: "bankBind",
          },
        });
      }
    },
  },
  computed: {
    bankInfo() {
      return this.$store.getters.bankInfo;
    },
    borrowPurpose() {
      return this.$store.getters.borrowPurpose;
    },
    receivedBank() {
      return this.$store.getters.receivedBank;
    }
  },
};
</script>

<style scoped lang="scss">
.loan-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.title {
  font-family: PingFang SC, PingFang SC;
  font-size: 18px;
  color: #ffffff;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .span {
    font-family: FontName, FontName;
    font-size: 12px;
    margin-left: 10px;
  }
}
.load-heand-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  background: linear-gradient(
    90deg,
    #ccefff 20.08%,
    #ffffff 65.66%,
    #abccff 100%
  );
  padding: 12px 11px;
  .info-item {
    font-size: 13px;
    color: #093e94;
    display: flex;
    align-items: center;
  }
  .step-img {
    display: flex;
    align-items: center;
    img {
      height: 6px;
    }
  }
  .step1-img {
    display: flex;
    align-items: center;
    img {
      width: 14px;
      height: 14px;
    }
  }
}
.load-amount-title,
.load-amount,
.load-amount-tip {
  font-size: 14px;
  text-align: center;
}
.load-amount-title {
  font-size: 16px;
  color: #333333;
}
.load-amount {
  font-weight: 600;
  font-size: 54px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.load-amount-tip {
  color: #777777;
  span {
    color: #333333;
  }
}
.load-card-tab {
  margin: 15px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  .tab-item {
    width: 44%;
    height: 56px;
    background: #EEF5FF;
    border-radius: 8px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    border: 1px solid #D7E6FF;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tab-item-left,
      .tab-item-right {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-left: 4px;
        }
        .span {
          color: #1d70f7;
          font-size: 14px;
        }
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #777777;
    }
  }
}
</style>
